import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { user } from 'services';
import { TableExt, TableInfo, themes, GridBox, GridUpdateMessage } from 'libs/ui';
import { getTableParams } from './grid.params';
import BenefitForm from './forms/benefit-type-form';

export const BenefitTypeGrid = (props) => {
  const { count, entries, className, theme, refresh } = props;

  const [showForm, setShowForm] = useState('');
  const [message, setMessage] = useState('');
  const [row, setRow] = useState(null);

  const { t } = useTranslation();

  // actions
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  const editItemAction = (row) => {
    setRow(row);
    setShowForm('editForm');
  };

  /**
   * close form
   * @returns
   */
  const closeForm = () => {
    setRow(null);
    setShowForm('');
  };

  // actions
  const actions = [];
  const rightAdd = user.haveRight('benefit_types_check.add');
  const rightEdit = user.haveRight('benefit_types_check.update');

  if (rightEdit) {
    actions.push({
      getTitle: (row) => (row.status === 'active' ? 'Заблокировать' : 'Активировать'),
      action: async (row) => {
        await api.call('benefit_types.change_status', { id: row.id, status: row.status === 'active' ? 'blocked' : 'active' });
        refresh(true);
      },
    });
  }

  // top actions
  const topActions = [];
  if (rightAdd) {
    topActions.push({ title: t('buttons.Добавить'), icon: 'fa-plus', theme: themes.blue, action: addItemAction });
  }

  const tableParams = useMemo(() => getTableParams(t), [t]);
  const items = Object.keys(entries).map((key) => entries[key]);
  const initial =
    showForm === 'addForm' || !row
      ? {}
      : {
          id: row.id,
          name: row.name,
          status: row.status,
          fn: row.data.fn,
          min_amount: Math.round(row.data?.min_amount / 100),
          amount: Math.round(row.data.amount / 100),
        };

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Скидки')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        clientId={props.clientId}
        onRowClick={rightEdit ? editItemAction : undefined}
        {...tableParams}
      />

      {showForm && <BenefitForm type={showForm} close={closeForm} id={row.id} setMessage={setMessage} refresh={props.refresh} initialValues={initial} />}

      {message && <GridUpdateMessage>{message}</GridUpdateMessage>}
    </GridBox>
  );
};
